import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { type FieldPath, type FieldValues, type PathValue, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InlineEditableText from '@/components/inline-editable-text';
type EditableBranchNameProps<TFormData extends FieldValues> = {
  canEdit: boolean;
  fieldName: FieldPath<TFormData>;
  onNameChange?: (name: string) => void;
};
export const EditableBranchName = t0 => {
  const $ = _c(27);
  const {
    canEdit,
    fieldName,
    onNameChange
  } = t0;
  const {
    control,
    register,
    setValue
  } = useFormContext();
  const {
    t
  } = useTranslation("playbook-builder");
  let t1;
  if ($[0] !== control || $[1] !== fieldName) {
    t1 = {
      control,
      name: fieldName
    };
    $[0] = control;
    $[1] = fieldName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const branchName = useWatch(t1);
  const value = String(branchName ?? "");
  let t2;
  let t3;
  if ($[3] !== fieldName || $[4] !== register) {
    t2 = () => {
      register(fieldName, {
        required: true
      });
    };
    t3 = [register, fieldName];
    $[3] = fieldName;
    $[4] = register;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== fieldName || $[8] !== onNameChange || $[9] !== setValue) {
    t4 = name => {
      setValue(fieldName, name as PathValue<TFormData, FieldPath<TFormData>>, {
        shouldDirty: true,
        shouldValidate: true
      });
      onNameChange?.(name);
    };
    $[7] = fieldName;
    $[8] = onNameChange;
    $[9] = setValue;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleChange = t4;
  let t5;
  if ($[11] !== t) {
    t5 = t(_temp);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t(_temp2);
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp3);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp4);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== canEdit || $[20] !== handleChange || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== value) {
    t9 = <InlineEditableText value={value} fallback={t5} placeholder={t6} ariaLabel={t7} editIconAriaLabel={t8} canEdit={canEdit} textClassName="text-body-2" buttonClassName="gap-2 px-0 py-0" shouldCloseOnBlur={_temp5} onChange={handleChange} />;
    $[19] = canEdit;
    $[20] = handleChange;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = value;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default EditableBranchName;
function _temp($) {
  return $.rulesNode.branch.setBranchNamePlaceholder;
}
function _temp2($_0) {
  return $_0.rulesNode.branch.actionNamePlaceholder;
}
function _temp3($_1) {
  return $_1.rulesNode.branch.editBranchName;
}
function _temp4($_2) {
  return $_2.rulesNode.branch.editBranchName;
}
function _temp5(next) {
  return next.trim().length > 0;
}